import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1460. 見積タスク編集
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  name: string;
  description?: string;
  due_date?: string;
  user_id: number;
};

const updateQuotationTask = (props: Props): Promise<QuotationTask> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.id}`, props);
};

export const useUpdateQuotationTask = () => {
  return useMutation({
    mutationFn: updateQuotationTask,
  });
};
